import { type PrincipalCalendarEvent, createPrincipalCalendarEvent } from 'models';
import { useQuery } from 'query';
import { getCalendarPrincipalEvents } from '../../services';
import { getCalendarPrincipalEventsListQueryKey } from './key';
import type { CalendarPrincipalEventsQueryFilter } from './types';

export const useCalendarPrincipalEventsQuery = ({ filter }: { filter: CalendarPrincipalEventsQueryFilter }) =>
  useQuery<PrincipalCalendarEvent[]>({
    async queryFn() {
      const { data } = await getCalendarPrincipalEvents({
        config: {
          params: {
            categories: filter.categories ? { $in: filter.categories } : undefined,
            end: filter.endDate.toISOString(),
            start: filter.startDate.toISOString(),
          },
        },
        routeParams: {
          calendarId: filter.calendarId,
          id: filter.principalId,
        },
      });

      return data.map((item) => createPrincipalCalendarEvent(item));
    },
    queryKey: getCalendarPrincipalEventsListQueryKey({ filter }),
    refetchInterval: 5 * 60 * 1000,
    staleTime: 5 * 60 * 1000,
  });
